export const localeIds = {
  'de_DE': '/e480d7fa-8827-4864-ae64-b85582a50249',
  'en_GB': '/f72ffadb-80d2-4683-90c1-3df827c503de',
  'fr_FR': '/968855eb-cafc-4f36-ad46-58a242aa4245',
  'es_ES': '/7881b25b-c742-42aa-b421-da4831a26d2b',
  'it_IT': '/33f1426e-d292-43fd-9055-b244da8bafc3',
  'nl_NL': '/4858956b-5e65-41fb-8ec7-18f82701b76a',
  'da_DK': '/305240ba-9fd9-4d7a-b066-5f8d970cc0e7',
  'ru_RU': '/9a40ec4a-1aa6-44eb-83dc-9f8fc0090654',
  'pt_PT': '/cc0995e2-722e-4354-9b69-b8cde4463f0f',
  'sl_SI': '/20a8b913-0fc8-4657-8b91-475856274880',
  'pl_PL': '/45d0f46b-95e2-4314-a645-c016dc61626a',
  'cs_CZ': '/3da6c00f-506b-428b-88a1-c9bcf10af4c6',
  'bg_BG': '/62a788c9-08ad-4786-9988-ea141bc60d14',
  'ro_RO': '/e020fc09-8ed4-4367-bb2f-7ff062faf85f',
  'sr_Latn_RS': '/59c9379a-3f37-44d2-9dcb-0b7f2bff0693',
  'hu_HU': '/94e8eb15-6b39-48e8-ba42-c533e68982df',
  'sk_SK': '/4dec673d-3df6-4953-a2c2-f0ee5af8dc2a',
  'hr_HR': '/bdbd181c-7736-4cb5-953b-cadf533fd621',
  'ar_001': '/e5fffc65-5420-41bb-b61a-3a5d420c8604',
  'ja_JP': '/23a56fa3-b25f-4704-99f4-f74abd6be95b',
  'tr_TR': '/f5eb1ee8-2b66-43f6-8743-d04c2f937468',
  'zh_CN': '/1232476d-bd1a-4e07-ab82-75e839b4f97c',
  'sv_SE': '/af998119-421f-4869-a25b-ba0624d7b211',
  'el_GR': '/0d28b5b5-1612-4b62-b8bd-915d83c584c8',
  'no_NO': '/37920e71-c8d6-43f3-818d-ffedb2cae664',
  'fi_FI': '/78686a21-f0b4-4a05-9a2c-a90bccb892a9',
  'lt_LT': '/359979ef-dc93-40fc-9997-220461765e21',
  'lv_LV': '/232d6341-3c0d-40e1-8300-172a5f71dc0b',
  'pt_BR': '/84ed134b-50b9-479e-87d6-c5ba4641f63f',
  'uk_UA': '/b0903ee7-c253-4b22-9a09-3895aed18961',
  'zh_Hant': '/02b1287a-1f21-49b8-99c1-d70ca02d9e08',
  'en_US': '/3ebefcf0-5fc1-4f82-85c2-73720bbe80f7',
  'et_EE': '/b88c5e22-1ab0-49ca-a50d-338cf47bec5a',
  'fa_IR': '/c74b9747-3cf0-49ad-bfa8-e9fd7c2aaa4e'
}

export const itemIds = {
  namespace_giata_id: '/fc62e500-42c8-4366-9c23-311836ba8821'
}

export const attributeIds = {
  name: '/8f5f2bba-cf85-4810-8a70-0ac782b242b9',
  localized_name: '/838e0cef-f032-40e8-9040-ee43d6f65800',
  city: '/ea3d0efa-6b88-4067-b38c-7f7f5e22d937',
  country: '/0407d1cd-add1-4f21-96ac-7d5a95700110',
  alias: '/e4938b86-766b-4e03-960f-7851eb19db8b'
}
